import { useState, useEffect } from "react";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import ModalUpselling from "ab-modal-upselling";
import DynamicContent from "../../../components/DynamicContent";
import {
  getPage,
  getProduct,
  getProductsByCategory,
  getCategory,
} from "ab-api-queries";

// import { getLinkFromTranslation, getLocaleFromContext } from "ab-functions";
import nextI18NextConfig from "../../../next-i18next.config.js";

const ExperienceBoxDetail = ({
  content = [],
  category,
  product,
  products,
  moduloCross,
}) => {
  const { i18n } = useTranslation("common");
  // console.log("ExperienceBoxDetail category", category);
  // console.log("ExperienceBoxDetail product", product);
  const [isSticky, setIsSticky] = useState(false);
  const [showUpsellingModal, setShowUpsellingModal] = useState(false);

  const handleSticky = () => {
    if (window.pageYOffset > window.innerHeight - 90) {
      document.getElementById("ab-historia-menu")?.classList.add("sticky");
      setIsSticky(true);
    } else {
      document.getElementById("ab-historia-menu")?.classList.remove("sticky");
      setIsSticky(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleSticky);

    if (window.pageYOffset > window.innerHeight - 90) {
      document.getElementById("ab-historia-menu")?.classList.add("sticky");
      setIsSticky(true);
    } else {
      document.getElementById("ab-historia-menu")?.classList.remove("sticky");
      setIsSticky(false);
    }

    return () => {
      window.removeEventListener("scroll", handleSticky);
    };
  }, []);
  if (content.length > 0 && product?.configuradorEbox) {
    return (
      <>
        {content?.map((itm, index) => (
          <DynamicContent
            {...itm}
            category={category}
            product={product}
            products={products}
            moduloCross={moduloCross}
            key={`${itm.fieldGroupName}-${index}`}
            setShowUpsellingModal={setShowUpsellingModal}
            i18n={i18n}
          />
        ))}
        {product?.configuradorEbox?.upselling ? (
          <ModalUpselling
            products={product?.configuradorEbox?.experiencias || products}
            product={product}
            setShowModal={setShowUpsellingModal}
            showModal={showUpsellingModal}
            i18n={i18n}
          />
        ) : null}
      </>
    );
  }
};
export async function getServerSideProps({ locale, params }) {
  const data = await getPage(
    `tienda/bono-regalo-experience-box/${params?.slug}`
  );
  const categoryData = await getCategory(params?.slug);
  const productData = await getProduct(params?.slug);
  const products = await getProductsByCategory(36); // 36 es el id de experience box -> 218  ingles y 411 aleman

  // const locale = getLocaleFromContext(context);
  // const redirectURL = getLinkFromTranslation(data?.nodeByUri?.translations, locale);

  // if (locale != 'es' && redirectURL) {
  //   return {
  //     redirect: {
  //       permanent: false,
  //       destination: redirectURL
  //     }
  //   };
  // }

  const translations = await serverSideTranslations(locale, ["common"]);

  return {
    props: {
      seo: data?.nodeByUri?.seo || {},
      content: data?.nodeByUri?.contenidoFlexible?.modulos || [],
      category: categoryData?.productCategory || {},
      product: productData?.product || {},
      products: products?.products?.nodes || [],
      footer: data?.headerFooter?.footer || {},
      moduloCross: data?.modulosCross,
      menu: data?.headerFooter?.menu,
      translations: data?.nodeByUri?.translations || null,
      language: data?.nodeByUri?.language || { code: "ES" },
      ...translations,
    }, // will be passed to the page component as props
    notFound:
      (!data?.nodeByUri?.contenidoFlexible?.modulos.length > 0 &&
        !productData?.product?.configuradorEbox) ||
      locale !== "es",
  };
}

export default ExperienceBoxDetail;
